// extracted by mini-css-extract-plugin
export default {"imgCont":"CloeBack_imgCont__j+OOf","imgbody":"CloeBack_imgbody__2R8F4"};